var SummaryType;
(function (SummaryType) {
    SummaryType["DISCHARGE"] = "A";
    SummaryType["EXTERNAL_TRANSFER"] = "E";
})(SummaryType || (SummaryType = {}));
export default SummaryType;
//# sourceMappingURL=summary-type.js.map